<template>
  <component :is="tag">
    <template v-for="cT in translationTags">
      <translation-tags
        v-if="cT.hasContent"
        :key="cT.id"
        :tag="cT.tag"
        :path="cT.path"
        v-bind="cT.attrs"
      />

      <i18n v-else :key="cT.id" :tag="cT.tag" :path="cT.path" v-bind="cT.attrs">
        <component
          v-for="slotKey in Object.keys(cT.slots)"
          :key="slotKey"
          :slot="slotKey"
          :is="cT.slots[slotKey].tag"
          v-bind="cT.slots[slotKey].attrs"
          >{{ cT.slots[slotKey].text }}</component
        >
        <span slot="space">&nbsp;</span>
        <br slot="break" />
      </i18n>
    </template>
  </component>
</template>

<script>
export default {
  name: 'TranslationTags',
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    path: {
      type: String,
      required: true
    },
    attrs: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      translationTag: this.tag,
      translationPath: this.path,
      translationAttrs: this.attrs
    }
  },
  computed: {
    translationList() {
      return [].concat(this.$t(this.path))
    },
    translationTags() {
      return this.translationList
        .filter(tag => typeof tag === 'object')
        .map((tag, tagIndex) => {
          let key = Object.keys(tag).filter(
            prop => prop !== 'attrs' && prop !== 'slots'
          )[0]
          let translationKey = `${this.translationPath}[${tagIndex}].${key}`

          return {
            id: Math.random()
              .toString(36)
              .substr(2, 9),
            tag: key,
            path: translationKey,
            slots: tag.slots || {},
            attrs: tag.attrs || {},
            hasContent: Array.isArray(this.$t(translationKey))
          }
        })
    }
  },
  watch: {
    '$props.tag'(tag) {
      this.translationTag = tag
    },
    '$props.path'(path) {
      this.translationPath = path
    },
    '$props.attrs'(attrs) {
      this.translationAttrs = attrs
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
</style>
